export default "__VITE_ASSET__CYvYK637__"